// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../node_modules/postcss-loader/dist/cjs.js!../library/style/colors.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.z1KtKDYP4yZEDwLbMNPA {
  text-align: center;
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-error"]};
  font-size: 0;
}

.ysQBlUMY8l2SO8LQL7b9 {
  font-size: 100px;
}

.khqxgoM8QtQbN341Iv6M {
  color: color-text;
  font-size: 20px;
  white-space: pre-line;
  margin-left: 40px;
  margin-right: 40px;
}

.e1CXDZUBE5vvC8_7sfmB {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  text-align: center;
}

.Pjtl0fLjq9t2FOngb48P {
  width: 100%;
  height: 50px;
}

.nUt5GUYXdqPjGlehNrV9 {
  position: absolute;    
  inset: 40px;
  width: 100%;
  height: 100%;
  margin: auto;
  padding: 40px;
  outline: none;
  overflow: auto;
  max-width: 625px;
  max-height: 600px;
  border-radius: 10px;
  background: rgb(255, 255, 255);
}

.nNmKFfF1ffVgvBvN6iid {
  z-index: 1000;
  position: fixed;
  inset: 0px;
  background-color: rgba(0, 0, 0, 0.4);
}

@media screen and (max-width: tablet-l) {
  .nUt5GUYXdqPjGlehNrV9 {
    inset: 0;
    padding: 10px;
    max-height: 70vh;
    max-width: 90vw;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/NotOwnerModal/NotOwnerModal.module.css"],"names":[],"mappings":"AAGA;EACE,kBAAkB;EAClB,mDAAkB;EAClB,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,aAAa;EACb,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,UAAU;EACV,oCAAoC;AACtC;;AAEA;EACE;IACE,QAAQ;IACR,aAAa;IACb,gBAAgB;IAChB,eAAe;EACjB;AACF","sourcesContent":["@value colors: \"../library/style/colors.css\";\n@value color-error from colors;\n\n.icon {\n  text-align: center;\n  color: color-error;\n  font-size: 0;\n}\n\n.materialIcons {\n  font-size: 100px;\n}\n\n.text {\n  color: color-text;\n  font-size: 20px;\n  white-space: pre-line;\n  margin-left: 40px;\n  margin-right: 40px;\n}\n\n.bodyModal {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  text-align: center;\n}\n\n.button {\n  width: 100%;\n  height: 50px;\n}\n\n.modal {\n  position: absolute;    \n  inset: 40px;\n  width: 100%;\n  height: 100%;\n  margin: auto;\n  padding: 40px;\n  outline: none;\n  overflow: auto;\n  max-width: 625px;\n  max-height: 600px;\n  border-radius: 10px;\n  background: rgb(255, 255, 255);\n}\n\n.modalOverlay {\n  z-index: 1000;\n  position: fixed;\n  inset: 0px;\n  background-color: rgba(0, 0, 0, 0.4);\n}\n\n@media screen and (max-width: tablet-l) {\n  .modal {\n    inset: 0;\n    padding: 10px;\n    max-height: 70vh;\n    max-width: 90vw;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"colors": `"../library/style/colors.css"`,
	"color-error": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-error"]}`,
	"icon": `z1KtKDYP4yZEDwLbMNPA`,
	"materialIcons": `ysQBlUMY8l2SO8LQL7b9`,
	"text": `khqxgoM8QtQbN341Iv6M`,
	"bodyModal": `e1CXDZUBE5vvC8_7sfmB`,
	"button": `Pjtl0fLjq9t2FOngb48P`,
	"modal": `nUt5GUYXdqPjGlehNrV9`,
	"modalOverlay": `nNmKFfF1ffVgvBvN6iid`
};
export default ___CSS_LOADER_EXPORT___;
